import styled from 'styled-components'

export const Mark = styled.div`
	width: 3px;
	height: 11px;
	background-color: ${props => props.theme.tag.blue};
`
